import type { Column } from "react-table";

import { FilterByApplication } from "../../../../components/Filters/FilterByApplication";
import { FilterByColumn } from "../../../../components/Filters/FilterByColumn";
import { FilterByStatus } from "../../../../components/Filters/FilterByStatus";
import type { IApplication } from "../../../../hooks/reactQueryHooks/useApplications";

interface FilterProps {
  applications: Array<IApplication>;
  columns: Column[] | null;
  isSingleCacheItem?: boolean;
}

export const Filters = ({
  applications,
  columns,
  isSingleCacheItem,
}: FilterProps) => {
  return (
    <div className="requests-filters">
      {!isSingleCacheItem && (
        <>
          <FilterByStatus />
          <FilterByApplication applications={applications} />
        </>
      )}
      <FilterByColumn columns={columns} />
    </div>
  );
};
